import { sva } from "styled-system/css";

export const featuredEventsRecipe = sva({
  slots: ["events", "heading"],
  base: {
    events: {
      h: "532px",
    },
    heading: {},
  },
  variants: {
    size: {
      mobile: {
        events: {
          h: "280px",
        },
      },
      tablet: {},
      desktop: {},
      large: {},
    },
    view: {
      month: {},
      selectedDates: {
        heading: {
          pr: "4px",
        },
      },
    },
  },
  defaultVariants: {
    size: "mobile",
    view: "month",
  },
});
